import React from 'react';
import { pillShape } from './Filters/MultiSelectPill';

const { borderRadius, ...buttonShape } = pillShape;
const groupBorder = { border: '1px solid var(--bs-gray-400)' };
const inactiveText = { color: 'var(--bs-gray-700)' };

export interface SegmentedOption<T extends string> {
  value: T;
  label: React.ReactNode;
}

interface SegmentedControlProps<T extends string> {
  options: SegmentedOption<T>[];
  value: T;
  size?: 'sm' | 'lg';
  onChange: (value: T) => void;
}

export default function SegmentedControl<T extends string>({ options, value, size = 'lg', onChange }: SegmentedControlProps<T>) {
  const small = size === 'sm';
  const sizeClass = small ? 'btn-sm py-1 ' : '';

  return <div className="d-inline-flex rounded overflow-hidden" style={groupBorder} role="radiogroup">
    {options.map((option, index) => {
      const active = option.value === value;
      const borderClass = index > 0 ? 'border-start ' : '';
      const activeClass = active ? 'bg-soft-primary text-primary' : 'btn-ghost-secondary';
      return <button
        key={option.value}
        type="button"
        role="radio"
        aria-checked={active}
        className={`btn ${sizeClass}d-inline-flex align-items-center gap-1 border-0 rounded-0 fw-semibold text-nowrap ${borderClass}${activeClass}`}
        style={small ? undefined : { ...buttonShape, ...(active ? undefined : inactiveText) }}
        onClick={() => onChange(option.value)}>
        {active && <i className="bi-check2 small" />}
        {option.label}
      </button>
    })}
  </div>;
}
